module.exports = __webpack_public_path__ + "img/trash-icon.c021079c.png";